import client from './client';

export interface ActiveConversationsDto {
  readonly conversationIds: readonly string[];
}

export async function fetchActiveConversationIds(): Promise<readonly string[]> {
  const response = await client.get<ActiveConversationsDto>('/api/v1/conversations/active');
  return response.data.conversationIds ?? [];
}
